import AsyncStorage from '@react-native-async-storage/async-storage'

// The server keeps no trace of an invitation to join: the day it was sent is
// remembered on this device, per account, so the card can say « déjà invité ».
const GHOST_INVITES_KEY = 'ghost_invites'

const storageKey = (accountId: string) => `${GHOST_INVITES_KEY}_${accountId}`

const readInvites = async (accountId: string): Promise<Record<string, string>> => {
  try {
    const stored = JSON.parse((await AsyncStorage.getItem(storageKey(accountId))) ?? '{}')
    return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {}
  } catch {
    return {}
  }
}

/** The day (ISO date) this card was last invited from this device, or null. */
export async function getGhostInviteDate(
  accountId: string,
  ghostId: string,
): Promise<string | null> {
  const date = (await readInvites(accountId))[ghostId]
  return typeof date === 'string' ? date : null
}

/** Remembers that this card was invited now; returns the date it stored. */
export async function rememberGhostInvite(
  accountId: string,
  ghostId: string,
  now: Date = new Date(),
): Promise<string> {
  const date = now.toISOString()
  const invites = await readInvites(accountId)
  await AsyncStorage.setItem(
    storageKey(accountId),
    JSON.stringify({ ...invites, [ghostId]: date }),
  ).catch(() => {})
  return date
}
